import { httpRequest } from "../../http";
import type { PeopleSelection, PickedPeople } from "@models/Discrepancy.model";

export class CommandPickPeople {
  async run(discrepancyId: number, selection: PeopleSelection): Promise<PickedPeople> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/${discrepancyId}/people/`;
    return httpRequest<PickedPeople, PeopleSelection>(url, { method: "POST", body: selection });
  }
}
